"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (date1, date2) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const milliseconds = Math.abs(date1 - date2);
    const days = Math.ceil(milliseconds / (1000 * 60 * 60 * 24));
    return {
        milliseconds,
        days
    };
};
